module.exports = __webpack_public_path__ + "static/media/menu24.165717bc.jpg";